import React from 'react'

export default function Footer() {
    return (
        <div className="text-center text-lg text-base-content p-20">
            footer of page
        </div>
    )
}
